import axios from "axios";
import { apiConfig } from "@/config/api.config";

export async function logEvent({
  action,
  feature,
  status,
  meta = {},
  user = null,
  eventTitle = "",
  timestamp = null,
}) {
  try {
    await axios.post(`${apiConfig.baseURL}/logs/event`, {
      action,
      eventTitle: eventTitle || action,
      userId: user?.id || null,
      username: user?.username,
      email: user?.email,
      status,
      meta: {
        ...meta,
        ip: window?.location?.hostname || "",
        userAgent: navigator.userAgent,
        feature,
      },
      timestamp: timestamp || new Date().toISOString(),
    });
  } catch (e) {
    // Logging failure is non-blocking
  }
}
